import PropTypes from "prop-types";
import * as Yup from "yup";
import { openSuccessDialog } from "../../../../utils/ui-components/pop-ups/SuccessDialog";
import { Form, Formik } from "formik";
import { Button, CircularProgress, Divider, Grid, InputAdornment, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { gridSpacing, IMAGE_SIZE, IMAGE_SUPPORTED_FORMATS } from "../../../../store/constants";
import TextField from "../../../../utils/ui-components/FormsUI/TextField";
import React, { useState } from "react";
import ItemImageUpload from "../../../../utils/ui-components/FormsUI/ItemImageUpload/item-image-upload.component";
import Select from "../../../../utils/ui-components/FormsUI/Select";
import { UserEditValues } from "./view-user";
import { UserService } from "../../../../assets/_services/user-service";
import PersonIcon from "@mui/icons-material/Person";
import SwitchWrapper from "../../../../utils/ui-components/FormsUI/Switch";
import { convertFileToBase64 } from "../../../../utils/utils";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

EditUser.propTypes = {
  initialItem: PropTypes.object.isRequired,
  setOpen: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  initialData: PropTypes.object,
};

const ACCOUNT_TYPES = [
  {
    value: 1,
    label: "Prepaid",
  },
  {
    value: 2,
    label: "Postpaid",
  },
];

const INDUSTRY_TYPES = [
  {
    value: 1,
    label: "Construction",
  },
  {
    value: 2,
    label: "Retail",
  },
  {
    value: 3,
    label: "Transportation",
  },
  {
    value: 4,
    label: "Financial Service",
  },
  {
    value: 5,
    label: "Agriculture",
  },
  {
    value: 6,
    label: "Education",
  },
  {
    value: 7,
    label: "Technology",
  },
  {
    value: 8,
    label: "Health Care",
  },
];

function EditUser({ initialItem, setOpen, fetchData, initialData }: any) {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));
  const [isLoading, setIsLoading] = useState(false);

  // const FORM_VALIDATION = Yup.object().shape({
  //   // profileImage: Yup.mixed()
  //   //   .nullable()
  //   //   .notRequired()
  //   //   .test("FILE_SIZE", "Uploaded file is too big.", ({ file: value }: any) => !value || (value && value?.size <= IMAGE_SIZE))
  //   //   .test(
  //   //     "FILE_FORMAT",
  //   //     "Uploaded file has unsupported format.",
  //   //     ({ file: value }: any) => !value || (value && IMAGE_SUPPORTED_FORMATS.includes(`${value?.type},`))
  //   //   ),
  //   accountType: Yup.number().required("You must make a selection"),
  //   businessName: Yup.string().required("Business name is required"),
  //   companyContact: Yup.string()
  //     .matches(/^((880|0)?(1){1}[3456789]{1}(\d){8},?)+$/, "Invalid mobile numbers pattern detected")
  //     .required("Company contact is required"),
  //   companyName: Yup.string().required("Representative name is required"),
  //   companyLocation: Yup.string().max(255, "maximum character count exceeded").required("Company location is required"),
  //   rateCardId: Yup.number().required("You must make a selection"),
  //   dataRateCardId: Yup.string().when("enableRewardCampaignCreation", {
  //     is: (val: any) => val,
  //     then: (schema: any) => schema.required("Select data reward rate card"),
  //     otherwise: (schema: any) => schema.notRequired(),
  //   }),
  //   email: Yup.string().email("Must be a valid email").max(255).required("Email is required"),
  //   enableApiCreation: Yup.boolean().notRequired(),
  //   enableReportDownload: Yup.boolean().notRequired(),
  //   enableRewardCampaignCreation: Yup.boolean().notRequired(),
  //   enableUserCreation: Yup.boolean().notRequired(),
  //   industryType: Yup.number().required("You must make a selection"),
  //   isCampaignNumberHash: Yup.boolean().notRequired(),
  //   isShowRateCard: Yup.boolean().notRequired(),
  //   mobile: Yup.string()
  //     .matches(/^((880|0)?(1){1}[3456789]{1}(\d){8},?)+$/, "Invalid mobile numbers pattern detected")
  //     .required("Mobile number is required"),
  //   nid: Yup.string().required("NID number is required"),
  //   representativeName: Yup.string().required("Representative name is required"),
  //   status: Yup.boolean().notRequired(),
  //   vat: Yup.string().required("VAT number is required"),
  //   userName: Yup.string()
  //     .required("Username is required")
  //     .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
  // });

  const FORM_VALIDATION = Yup.object().shape({
    profileImage: Yup.mixed()
      .nullable()
      .notRequired()
      .test("FILE_SIZE", "Uploaded file is too big.", ({ file: value }: any) => !value || (value && value?.size <= IMAGE_SIZE))
      .test(
        "FILE_FORMAT",
        "Uploaded file has unsupported format.",
        ({ file: value }: any) => !value || (value && IMAGE_SUPPORTED_FORMATS.includes(`${value?.type},`)),
      ),
    representativeName: Yup.string().required("Representative name is required").trim("Enter valid name"),
    email: Yup.string().email("Must be a valid email").max(255).required("Email is required"),
    nid: Yup.string().required("NID number is required"),
    vat: Yup.string().required("VAT number is required"),
    companyName: Yup.string().required("Company name is required").trim("Enter valid name"),
    businessName: Yup.string().required("Business name is required").trim("Enter valid name"),
    companyContact: Yup.string()
      .matches(/^((880|0)?(1){1}[3456789]{1}(\d){8},?)+$/, "Invalid mobile numbers pattern detected")
      .required("Please enter company contact number"),
    mobile: Yup.string()
      .matches(/^((880|0)?(1){1}[3456789]{1}(\d){8},?)+$/, "Invalid mobile numbers pattern detected")
      .required("Mobile number is required"),
    companyLocation: Yup.string().max(255, "maximum character count exceeded").required("Company location is required"),
    username: Yup.string()
      .required("Username is required")
      .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
    industryType: Yup.number().required("You must make a selection"),
    accountType: Yup.number().required("You must make a selection"),
    rateCardId: Yup.string().required("You must select a sms rate card"),
    dataRateCardId: Yup.string().when("enableRewardCampaignCreation", {
      is: (val: any) => val,
      then: (schema: any) => schema.required("Select data reward rate card"),
      otherwise: (schema: any) => schema.notRequired(),
    }),
    status: Yup.boolean().notRequired(),
    isShowRateCard: Yup.boolean().notRequired(),
    enableUserCreation: Yup.boolean().notRequired(),
    enableApiCreation: Yup.boolean().notRequired(),
    enableReportDownload: Yup.boolean().notRequired(),
    isCampaignNumberHash: Yup.boolean().notRequired(),
    enableRewardCampaignCreation: Yup.boolean().notRequired(),
  });

  const updateUser = (itemData: UserEditValues, setSubmitting: (isSubmitting: boolean) => void) => {
    // console.log(itemData)
    setIsLoading(true);

    let data: any;
    convertFileToBase64(itemData.profileImage)
      .then((base64) => {
        data = { ...itemData, profileImage: base64 };
      })
      .catch((error) => {
        data = { ...itemData, profileImage: "" };
      })
      .finally(() => {
        let formData = {
          userId: itemData.id,
          representativeName: itemData.representativeName,
          email: itemData.email,
          userName: itemData.username,
          mobile: itemData.mobile,
          companyName: itemData.companyName,
          businessName: itemData.businessName,
          companyContact: itemData.companyContact,
          companyLocation: itemData.companyLocation,
          industryType: itemData.industryType,
          accountType: Number(itemData.accountType) - 1,
          NID: itemData.nid,
          VAT: itemData.vat,
          rateCardId: itemData.rateCardId,
          dataRateCardId: itemData?.enableRewardCampaignCreation ? itemData?.dataRateCardId : 0,
          status: itemData.status ? 1 : 0,
          isAbleToCreateChildUser: itemData.enableUserCreation ? 1 : 0,
          isRateCardShow: itemData.isShowRateCard ? 1 : 0,
          isApiUser: itemData.enableApiCreation ? 1 : 0,
          isReportDownload: itemData?.enableReportDownload ? 1 : 0,
          isNumberListHashed: itemData?.isCampaignNumberHash ? 1 : 0,
          isDataRewardAvailable: itemData?.enableRewardCampaignCreation ? 1 : 0,
          image: data.profileImage,
          isProfileShow: 1,
        };
        UserService.updateOwnerUser(formData).then((response) => {
          setSubmitting(false);
          if (response.isSuccess) {
            openSuccessDialog("Success", response.data.comment);
            setOpen(false);
            fetchData();
            setIsLoading(false);
          } else {
            setSubmitting(false);
            setIsLoading(false);
          }
        });
      });
  };

  return (
    <Formik
      initialValues={{
        ...initialItem,
      }}
      validationSchema={FORM_VALIDATION}
      onSubmit={(values: UserEditValues, { setSubmitting }) => {
        updateUser(values, setSubmitting);
      }}
    >
      {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
        <Form>
          <Grid container columnSpacing={gridSpacing}>
            <Grid item xs={12} lg={4} md={12} marginBottom={2}>
              <Grid container>
                <Grid item xs={12}>
                  <ItemImageUpload
                    accept=".jpg,.png,.jpeg"
                    label="Upload your profile/company photo"
                    maxFileSizeInBytes={IMAGE_SIZE}
                    name="profileImage"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Divider sx={{ my: 1 }} textAlign="left">
                        <Typography variant="caption" fontWeight={"bold"}>
                          User Access
                        </Typography>
                      </Divider>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="isShowRateCard"
                            label={values.isShowRateCard ? "Show Rate Card" : "Hide Rate Card"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="enableUserCreation"
                            label={values.enableUserCreation ? "Enable User Creation" : "Disable User Creation"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="enableApiCreation"
                            label={values.enableApiCreation ? "Enable API Campaign" : "Disable API Campaign"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item lg={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="enableRewardCampaignCreation"
                            label={values.enableRewardCampaignCreation ? "Enable Data Reward Campaign" : "Disable Data Reward Campaign"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="enableReportDownload"
                            label={values.enableReportDownload ? "Enable Report Download" : "Disable Report Download"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <Tooltip title="fire">
                            <HelpOutlineIcon fontSize="small" color="disabled" />
                          </Tooltip>
                          <SwitchWrapper
                            name="isCampaignNumberHash"
                            label={values.isCampaignNumberHash ? "Hashed Campaign Numbers" : "Show Campaign Numbers"}
                            style={{ co: "green" }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={8} md={12} marginBottom={2}>
              <Grid container columnSpacing={gridSpacing}>
                <Grid item xs={12} md={6}>
                  <TextField required label="Company Name" name="companyName" type="text" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField required label="Business Name" name="businessName" type="text" />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    required
                    label="Company Contact"
                    name="companyContact"
                    type="tel"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">+880 |</InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    required
                    label="Mobile"
                    name="mobile"
                    type="tel"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">+880 |</InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField required label="Email" name="email" type="email" />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField required label="Company Location" name="companyLocation" type="text" multiline />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Select label="Industry Type *" name="industryType" options={INDUSTRY_TYPES} customHandleChange={() => {}} />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Select label="Account Type *" name="accountType" options={ACCOUNT_TYPES} customHandleChange={() => {}} />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <Select label="Rate Card *" name="rateCardId" options={initialData?.rateCard} customHandleChange={() => {}} />
                </Grid>
                {values.enableRewardCampaignCreation && (
                  <Grid item xs={12} sm={6} lg={6} md={4}>
                    <Select label="Data Reward Rate Card *" name="dataRateCardId" options={initialData?.dataRateCard} customHandleChange={() => {}} />
                  </Grid>
                )}
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <TextField required label="Representative Name" name="representativeName" type="text" />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <TextField required label="NID Number" name="nid" type="text" />
                </Grid>
                <Grid item xs={12} lg={6} sm={6} md={6}>
                  <TextField required label="VAT Number" name="vat" type="text" />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextField
                    type={"text"}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                    name="username"
                    label="Username"
                    placeholder="Username"
                    required
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item lg={2} md={4} sm={6} xs={12}>
              <SwitchWrapper name="status" label={values.status ? "ACTIVE" : "INACTIVE"} style={{ co: "green" }} />
            </Grid>
            <Grid item xs={12} sm={6} lg={3} md={4}>
              <SwitchWrapper
                name="enableUserCreation"
                label={values.enableUserCreation ? "Enable User Creation" : "Disable User Creation"}
                style={{ co: "green" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3} md={4}>
              <SwitchWrapper name="isShowRateCard" label={values.isShowRateCard ? "Show Rate Card" : "Hide Rate Card"} style={{ co: "green" }} />
            </Grid>
            <Grid item xs={12} sm={6} lg={4} md={4}>
              <SwitchWrapper
                name="isCampaignNumberHash"
                label={values.isCampaignNumberHash ? "Hashed Campaign Numbers" : "Show Campaign Numbers"}
                style={{ co: "green" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={2.5} md={4}>
              <SwitchWrapper
                name="enableApiCreation"
                label={values.enableApiCreation ? "Enable Api Campaign" : "Disable Api Campaign"}
                style={{ co: "green" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={4} md={4}>
              <SwitchWrapper
                name="enableReportDownload"
                label={values.enableReportDownload ? "Enable Report Download" : "Disable Report Download"}
                style={{ co: "green" }}
              />
            </Grid> */}

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  py: 2,
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  // onClick={() => console.log(values)}
                  // disabled={isSubmitting}
                  disabled={isSubmitting || !isValid || !dirty}
                >
                  {isLoading && (
                    <CircularProgress
                      size={"20px"}
                      sx={{
                        mr: 1,
                        color: "gray",
                      }}
                    />
                  )}
                  Update User
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default EditUser;
